import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../hooks/useFetch";
import { useAppStore } from "../../stores/RootStore";
import { Division } from "../../types/types";
import { Button } from "../../ui/Button";
import { Input } from "../../ui/Input/Input";
import { Label } from "../../ui/Label/Label";
import { ScrollArea } from "../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../ui/SelectButton/SelectButton";
import { NavLink, useNavigate } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";

const AddDivision = () => {
  let navigate = useNavigate()
  const divisions = useAppStore((store) => store.divisions)!;
  const divisionsList = divisions?.map((division) => {
    return { value: division.id, label: division.attributes.name };
  })!;

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, setValue, control } = useForm({
    defaultValues: {
      name: "",
      cipher: "",
      order_number: "",
      parent: null,
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/divisions`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          cipher: formData.cipher,
          order_number: formData.order_number,
          parent_id: formData.parent ? formData.parent : "",
        },
      },
    });
    reset();
  };

  const setDivisions = useAppStore((store) => store.setDivisions);

  const addDivision = (itemSaveResponse: { data: unknown }) => {
    const newDivisionData = itemSaveResponse.data as unknown as Division;
    setDivisions([...divisions, newDivisionData]);
  };

  useEffect(() => {
    if (!itemSaveResponse) return;
    addDivision(itemSaveResponse);
    navigate('/data/divisions')
  }, [itemSaveResponse]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/divisions"} className="text-sm flex gap-2 items-center text-muted-foreground hover:text-primary"><TbArrowLeft />{t("divisions")}</NavLink>
            <span className="text-2xl font-semibold">{t('adding_division')}</span>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="px-6">
          <div className="flex flex-col w-full h-full gap-2">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("division_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="parent"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("parent_division")}</Label>
                  <SelectButton
                    label={t("choose_division")}
                    searchable={true}
                    options={divisionsList}
                    value={value ? divisionsList.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />

            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddDivision;
